// extracted by mini-css-extract-plugin
export default {"slides":"Slides_slides__5GWL8","controls":"Slides_controls__51dJB","control":"Slides_control__zLBBu","control--active":"Slides_control--active__V9tsA"};